class PrintManager {

    constructor() {
        this.queue = [];
        this.active = 0;
        this.maxConcurrent = 4;

        this.total = 0;
        this.completed = 0;

        this.listeners = [];
    }

    subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }

    notify() {
        this.listeners.forEach(l =>
            l({
                total: this.total,
                completed: this.completed,
                active: this.active
            })
        );
    }

    add(job) {
        // SI la cola anterior terminó completamente, reiniciar
        if (this.completed === this.total && this.active === 0) {
            this.total = 0;
            this.completed = 0;
        }

        this.queue.push(job);
        this.total++;
        this.notify();
        this.process();
    }

    async process() {

        while (this.active < this.maxConcurrent && this.queue.length > 0) {

            const job = this.queue.shift();

            this.active++;
            this.notify();

            job()
                .catch(console.error)
                .finally(() => {
                    this.active--;
                    this.completed++;
                    this.notify();
                    this.process();
                });
        }
    }

    reset() {
        this.queue = [];
        this.active = 0;
        this.total = 0;
        this.completed = 0;
        this.notify();
    }
}

export default new PrintManager();